const TENANT_KEY = "tenantId";

export function setTenantId(tenantId) {
	if (tenantId && typeof tenantId === "string" && tenantId.trim().length > 0) {
		localStorage.setItem(TENANT_KEY, tenantId.trim());
		return;
	}
	localStorage.removeItem(TENANT_KEY);
}

export function getTenantId() {
	return localStorage.getItem(TENANT_KEY) || null;
}

export function clearTenantId() {
	localStorage.removeItem(TENANT_KEY);
}

export { TENANT_KEY };



